import React from "react";
import { Alert, Col, Dropdown, Form, FormCheck, InputGroup, Modal, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  addInterventionsToGroup,
  changeSelectedInterventionGroup,
  getInterventions,
  hideInterventionLibraryModal,
  patchInterventionGroup,
} from "../../../../../store/onboarding/cases/actions";
import { connect, useSelector } from "react-redux";
import {
  ConcernArea,
  ConcernType,
  ConcernTypeDisplayedNames,
  ExtendedInterventionTarget,
  ExtendedInterventionTargetDisplayedNames,
  GoalTypes,
  GoalTypesDisplayedNames,
  Intervention,
  InterventionGroup,
  InterventionGroupPatchRequest,
  InterventionTarget,
  InterventionTargetDisplayedNames,
} from "../../../../../store/onboarding/cases/types";
import { ValueType } from "react-select/src/types";
import { faChevronLeft, faDownload, faSearch } from "@fortawesome/free-solid-svg-icons";
import ModifyInterventionPopup from "./ModifyInterventionPopup";
import ModifyingInterventionBody from "./ModifyingInterventionBody";
import InterventionGroupTooltip from "./common/InterventionGroupTooltip";
import GroupCountIcon from "../group-students/common/GroupCountIcon";
import { Identifier, SkillFocusArea } from "../../../../../store/groups/types";
import { getSkillFocuses } from "../../../../../store/groups/actions";
import { UserInfo } from "../../../../../store/auth/types";
import LoadingIndicator from "../../LoadingIndicator";
import { ReactSelectOption } from "../../../../../store/onboarding/types";
import { getFullNameForStudent } from "../../../../../utils/StudentMapUtils";
import { toastr } from "react-redux-toastr";
import ModalCloseButton from "../group-students/common/ModalCloseButton";
import InterventionItem from "../../../../pages/coach-dashboard/tabs/explore-and-learn/intervention-library/InterventionItem";
import { addInterventionToPlan } from "../../../../utils";
import InterventionEditButton from "./InterventionEditButton";
import { RouteComponentProps, withRouter } from "react-router";
import jsPDF from "jspdf";
// @ts-ignore
import html2pdf from "html2pdf.js";
import InterventionShared from "../../../../pages/coach-dashboard/tabs/explore-and-learn/intervention-library/new-intervention-modal/intervention-shared/InterventionShared";
import PdfBtn from "../../../../pages/coach-dashboard/tabs/explore-and-learn/intervention-library/PdfBtn";
import { uniqueByKey } from "../../../../../utils/NamesUtils";

type PropsFromState = {
  callbacks?: {
    onBack: Function;
  };
  userInfo: UserInfo | undefined;
  interventionGroup?: InterventionGroup;
  selectedIntervention?: Intervention;
  interventions: Array<Intervention>;
  skillFocusInfo: Array<SkillFocusArea>;
  identifiersInfo: { [identifier: string]: Identifier };
  showModal: boolean;
  interventionCalledFromFBA: boolean;
  isSaveInState: boolean;
  createdIntervention?: Intervention;
  isLoading: {
    addInterventionsToGroup: boolean;
    getInterventions: boolean;
  };
  errors: {
    addInterventionsToGroup?: string;
  };
};

type DispatchProps = {
  getInterventions: (concernType?: ConcernType) => any;
  hideInterventionLibraryModal: () => any;
  getSkillFocuses: () => any;
  addInterventionsToGroup: (
    interventionGroupId: number,
    interventionIds: Array<number>
  ) => any;
  patchInterventionGroup: (
    groupId: number,
    request: InterventionGroupPatchRequest
  ) => any;
  changeSelectedInterventionGroup: (group: InterventionGroup) => any;
};

type MatchParams = {
  tabName: string;
};

type Props = PropsFromState & DispatchProps & RouteComponentProps<MatchParams>;

type State = {
  recommendedOnly: boolean;
  interventions: Array<Intervention>;
  targetPersonFilter?: ReactSelectOption<InterventionTarget>;
  concernTypeFilter?: ReactSelectOption<ConcernType>;
  areaFilter?: ReactSelectOption<string>;
  areaOfNeedFilter?: ReactSelectOption<string>;
  createdByFilter?: ReactSelectOption<number>;
  selectedIntervention?: Intervention; // <-- Make optional
  step: number; //todo
  showModifyInterventionPopup: boolean;
  searchStringFilter?: string;
  contentRef: React.RefObject<HTMLDivElement | null>;
  shareByDistrict: boolean;
};

const RECOMMENDATIONS_LIMIT = 1500000;


class InterventionLibraryModal extends React.Component<Props, State> {
  defState: Readonly<State> = {
    recommendedOnly: true,
    step: 0,
    interventions: [],
    createdByFilter: undefined,
    targetPersonFilter: undefined,
    selectedIntervention: undefined,
    showModifyInterventionPopup: false,
    searchStringFilter: undefined,
    contentRef: React.createRef(),
    shareByDistrict: false
  };
  state: Readonly<State> = this.defState;

  componentDidMount(): void {
    this.props.getSkillFocuses();
    this.props.getInterventions();
  }
  
  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      this.props.createdIntervention &&
      this.props.interventionGroup &&
      prevProps.isLoading.addInterventionsToGroup &&
      !this.props.isLoading.addInterventionsToGroup
    ) {
      if (this.props.errors.addInterventionsToGroup) {
        toastr.error("Error", this.props.errors.addInterventionsToGroup);
      } else {
        const { interventionGroup, createdIntervention } = this.props;
        
        const changedPlan = addInterventionToPlan(
          interventionGroup.intervention_plan,
          createdIntervention,
          interventionGroup.interventions
        );
        this.props.patchInterventionGroup(interventionGroup.id, {
          intervention_plan: changedPlan,
        });
      }
    }

    if (
      prevProps.isLoading.addInterventionsToGroup &&
      !this.props.isLoading.addInterventionsToGroup
    ) {
      if (this.props.errors.addInterventionsToGroup) {
        toastr.error("Error", this.props.errors.addInterventionsToGroup);
      } else {
        this.props.hideInterventionLibraryModal();
        this.props.callbacks?.onBack();
      }
    }
    
    if (prevProps.interventions !== this.props.interventions) {
      if(!this.props.interventionGroup?.recommendation_group_key) { //RC-1414 show all for manual grouping
         this.setState({
          recommendedOnly: false
        })
      }
      if (this.state.recommendedOnly) {
        this.setState({
          interventions: this.getRecommendedOnlyInterventions(),
        });
      } else {
        this.setState({
          interventions: this.props.interventions,
        });
      }
    }

    if(prevProps.showModal !== this.props.showModal) {
      this.setState({
        searchStringFilter: undefined,
        createdByFilter: undefined,
        targetPersonFilter: undefined,
        concernTypeFilter: undefined,
        areaFilter: undefined,
        areaOfNeedFilter: undefined,
      });
    }
  }

  getRecommendedOnlyInterventions = () => {
    const { identifiersInfo, interventionGroup, interventions } = this.props;
    let fInterventions = interventions;
    let furtherInterventions: Intervention[] = [];

    if (interventionGroup) {
      const focuses = interventionGroup.focuses;
      let filteredInterventions: Array<Intervention> = fInterventions;
      let goalType = interventionGroup.goal_type ??
        (interventionGroup.recommendation_group_key !== null ||
          !!interventionGroup.focuses?.length
          ? GoalTypes.ACADEMIC
          : null);

      if ((this.props.match.params.tabName == 'groups/behavior') && (interventionGroup.goal_type == GoalTypes.BEHAVIOR)) {
        goalType = interventionGroup.goal_type ??
          (interventionGroup.recommendation_group_key !== null ||
            !!interventionGroup.focuses?.length
            ? GoalTypes.BEHAVIOR
            : null);
      }
      /*
        Interventions Filtering Logic:
        --------------------------------
        This block progressively narrows down `fInterventions` into `furtherInterventions`
        based on multiple prioritized conditions using focuses, identifiers, and skill areas.

        Order of filtering:
        1. **Specific identifier match**  
          - If an intervention has a `focus` matching a "specific" identifier, include it.  
          - Special handling: "diag_area_vocab" is extracted from "diag_area_comprehension".

        2. **Skill focus of specific match**  
          - If not intervention matches the specific identifier then match with skill focus identifier of the specific if matches then, include it.

        3. **Skill focus match**  
          - If still empty, check for intervention's focus matching a `skill_focus` identifier.

        4. **Fallback: Area of need match when no focuses**  
          - If still empty but interventions exist without `focuses`, include those whose
            `skill_areas` match a focus’s `area_identifier`.

        5. **Fallback: Area of need match**  
          - If still empty, include interventions whose `skill_areas` match the focus’s `area_identifier`.

        Final fallback:
        - If no matches at all:
          - If `focuses` exist → return interventions filtered by `skill_areas`.
          - Otherwise → return all interventions.

        Additional filtering:
        - If `goalType` is specified, only keep interventions whose `concern_area`
          matches the goal (ACADEMIC / BEHAVIOR / BOTH).
      */


      if (focuses) {
        const idsAdded = new Set();
        /* // Recommendation group key
        fInterventions.forEach((intervention) => {
          if (idsAdded.has(intervention.id)) {
            return;
          }

          let toTest: string[] = [];
          if (intervention.focuses) {
            toTest = toTest.concat(intervention.focuses);
          }

          if (intervention.skill_areas) {
            toTest = toTest.concat(intervention.skill_areas);
          }

          let addedFromRecs = false;
          if (interventionGroup.recommendation_group_key) {
            if (
              toTest &&
              toTest.includes(interventionGroup.recommendation_group_key)
              ) {
                filteredInterventions.push(intervention);
                idsAdded.add(intervention.id);
                addedFromRecs = true;
              } 
            if (interventionGroup.recommendation_group_key === "ABC" &&
              (toTest.includes("A") || toTest.includes("B") ||
                toTest.includes("C"))) {
              filteredInterventions.push(intervention);
              idsAdded.add(intervention.id);
              addedFromRecs = true;
            }
          }
        });
        console.log('recommendation group key', filteredInterventions);


        if (!filteredInterventions.length){
          filteredInterventions = fInterventions
        } */


        // first condition specific id
        const idsAddedForInterventions = new Set();

        filteredInterventions.forEach((intervention) => {
          if (idsAddedForInterventions.has(intervention.id)) {
            return;
          }

          let toTest: string[] = [];
          if (intervention.focuses) {
            toTest = toTest.concat(intervention.focuses);
          }

          focuses.forEach((focus) => {
            const identifier: Identifier | undefined =
              identifiersInfo[focus.identifier];
            const readRecMappedValue: string =
              READ_REC_ID_MAP[focus.identifier];

            if ((readRecMappedValue === 'diag_area_comprehension') && toTest.includes('diag_area_vocab')) {
              // Since we don't have any rr for vocab we need to extract related interventions using comprehension
              furtherInterventions.push(intervention);
              idsAdded.add(intervention.id);
            }
            if (identifier.area_identifier == "diag_area_vocab" && toTest.includes("diag_area_comprehension")) {
              // to stop recommendation of comprehension when diag area is vocabulary
            } else if (toTest && identifier && (identifier.type == 'specific') && toTest.includes(identifier.specific_identifier!)) {
              furtherInterventions.push(intervention);
              idsAdded.add(intervention.id);
            }
          });
        });

        // second condition skill focus of specific, and skill focus
        filteredInterventions.forEach((intervention) => {
          if (idsAdded.has(intervention.id)) {
            return;
          }

          let toTest: string[] = [];
          if (intervention.focuses) {
            toTest = toTest.concat(intervention.focuses);
          }
          focuses.forEach((focus) => {
            const identifier: Identifier | undefined =
              identifiersInfo[focus.identifier];
            if (toTest.includes(identifier?.skill_focus_identifier!)) {
              furtherInterventions.push(intervention);
              idsAdded.add(intervention.id);
            }
          });
        });

        // third condition skill focus
        if (!furtherInterventions.length) {
          const idsAdded = new Set();
          filteredInterventions.forEach((intervention) => {
            if (idsAdded.has(intervention.id)) {
              return;
            }

            let toTest: string[] = [];
            if (intervention.focuses) {
              toTest = toTest.concat(intervention.focuses);
            }

            focuses.forEach((focus) => {
              const identifier: Identifier | undefined =
                identifiersInfo[focus.identifier];

              if ((identifier.type == 'skill_focus') && toTest.includes(identifier.identifier_info[0])) { // ID
                furtherInterventions.push(intervention);
                idsAdded.add(intervention.id);
              }
            });
          });
        }

        // fourth condition area of need match, if no focus available for intervention 
        if (furtherInterventions.length) {
          const idsAdded = new Set();
          console.log('filteredInterventions ', filteredInterventions);

          filteredInterventions.concat(fInterventions).forEach((intervention) => {
            if (idsAdded.has(intervention.id)) {
              return;
            }
            if (!intervention.focuses) {
              console.log('inter - ', intervention.name);

              if (intervention.skill_areas) {
                focuses.forEach((focus) => {
                  const readRecMappedValue: Identifier | undefined =
                    identifiersInfo[focus.identifier];
                  const behaveRecMappedValue: Identifier | undefined =
                    identifiersInfo[focus.identifier];

                  if (intervention.skill_areas.includes(readRecMappedValue.area_identifier || behaveRecMappedValue.area_identifier)) {
                    furtherInterventions.push(intervention);
                    idsAdded.add(intervention.id);
                  }
                });
              }

            }
          });
        }
        /*
        if(!furtherInterventions.length) {
          const idsAddedGroups = new Set();
          filteredInterventions.forEach((intervention) => {
            if (idsAddedGroups.has(intervention.id)) {
              return;
            }
    
            let toTest: string[] = [];
            if (intervention.focuses) {
              toTest = toTest.concat(intervention.focuses);
            }
    
            if (intervention.skill_areas) {
              toTest = toTest.concat(intervention.skill_areas);
            }
    
            focuses.forEach((focus) => {
            const identifier: Identifier | undefined =
              identifiersInfo[focus.identifier];
  
              if (toTest && identifier) {
                if(toTest.includes(identifier.identifier_info[3])) { // Sub Group
                  furtherInterventions.push(intervention);
                  idsAddedGroups.add(intervention.id);
                } else if(toTest.includes(identifier.identifier_info[2])) { // Main Group
                  furtherInterventions.push(intervention);
                  idsAddedGroups.add(intervention.id);
                } 
              }
            });
          });
        }
        */


        // fifth condition area of need
        if (!furtherInterventions.length) {
          const idsAdded = new Set();
          filteredInterventions.forEach((intervention) => {
            if (idsAdded.has(intervention.id)) {
              return;
            }

            if (intervention.skill_areas) {
              focuses.forEach((focus) => {
                const readRecMappedValue: Identifier | undefined =
                  identifiersInfo[focus.identifier];
                const behaveRecMappedValue: Identifier | undefined =
                  identifiersInfo[focus.identifier];

                if (intervention.skill_areas.includes(readRecMappedValue.area_identifier || behaveRecMappedValue.area_identifier)) {
                  furtherInterventions.push(intervention);
                  idsAdded.add(intervention.id);
                }
              });
            }
          });
        }

      }

      if (furtherInterventions.length === 0) {
        if (focuses?.length) {
          focuses!.forEach((focus) => {
            const identifier: Identifier | undefined =
              (focus.identifier != undefined)
                ? identifiersInfo[focus.identifier]
                : identifiersInfo[focus as any];
            let fluencyComperihance = interventions.filter((intervention: Intervention) =>
              (intervention.skill_areas != null)
              && (intervention.skill_areas.length > 0)
              && (identifier != undefined)
              && intervention.skill_areas.find((skillArea) => skillArea == identifier.area_identifier));

            furtherInterventions = fluencyComperihance;
          });



        } else {
          furtherInterventions = interventions;
        }
      }

      if (goalType) {

        fInterventions = fInterventions.filter((intervention) => {
          if (goalType == GoalTypes.ACADEMIC) {
            return (
              intervention.concern_area === ConcernArea.ACADEMIC ||
              intervention.concern_area === ConcernArea.BOTH
            );
          } else if (goalType == GoalTypes.BEHAVIOR) {
            return (
              intervention.concern_area === ConcernArea.BEHAVIOR ||
              intervention.concern_area === ConcernArea.BOTH
            );
          } else {
            return true;
          }
        });
      }
    }

    return furtherInterventions.slice(0, RECOMMENDATIONS_LIMIT).sort((a, b) => a.name.localeCompare(b.name));
  };

  handleModalClose = () => {
    this.setState({ showModifyInterventionPopup: false });
    this.props.hideInterventionLibraryModal();
    this.props.callbacks?.onBack();
  };

  handleBackClick = () => {
    this.props.hideInterventionLibraryModal();
    this.props.callbacks?.onBack();
  };

  handleModalShow = () => {
    if (this.props.selectedIntervention) {
      this.setState({
        ...this.defState,
        step: 1,
        selectedIntervention: this.props.selectedIntervention,
        interventions: this.getRecommendedOnlyInterventions(),
      });
    } else {
      this.setState({
        ...this.defState,
        interventions: this.getRecommendedOnlyInterventions(),
      });
    }

    if(this.props.interventionGroup?.finished) {
      this.handleRecommendedOnlyCheck(false);
    }
  };

  getInterventionTargetValues = (): Array<
    ReactSelectOption<InterventionTarget>
  > => {
    return [...Object.keys(InterventionTarget)
      .filter((value) => !isNaN(+value))
      .map((value: string): any => ({
        label: InterventionTargetDisplayedNames[+value as InterventionTarget],
        value: value,
      })).sort((a, b) => a.label.localeCompare(b.label)), {
          label: ExtendedInterventionTargetDisplayedNames[ExtendedInterventionTarget.INDIVIDUALS_AND_SMALL_GROUPS],
          value: ExtendedInterventionTarget.INDIVIDUALS_AND_SMALL_GROUPS.toString(),
        },
        {
          label: ExtendedInterventionTargetDisplayedNames[ExtendedInterventionTarget.WHOLE_CLASS_AND_SMALL_GROUPS],
          value: ExtendedInterventionTarget.WHOLE_CLASS_AND_SMALL_GROUPS.toString(),
        } 
      ];
  };

  getConcernTypeValues = (): Array<ReactSelectOption<ConcernType>> => {
    return Object.keys(ConcernType)
      .filter((value) => !isNaN(+value))
      .map((value: string): any => ({
        label: ConcernTypeDisplayedNames[+value as ConcernType],
        value: value,
      }));
  };

  getAreaValues = (): Array<ReactSelectOption<string>> => {
    const interventionTags = new Set();
    this.props.interventions.forEach((intervention) => {
      const focuses = intervention.focuses || [];
      const skillAreas = intervention.skill_areas || [];

      focuses
        .concat(skillAreas)
        .forEach((ident) => interventionTags.add(ident));
    });

    const possible = this.props.skillFocusInfo.map((sfInfo) => ({
      label: sfInfo.display_name,
      value: sfInfo.identifier,
    }));

    return possible.filter((p) => interventionTags.has(p.value));
  };

  getAreaOfNeedValues = (): Array<ReactSelectOption<string>> => {
    const areas = this.props.skillFocusInfo;
    return areas.flatMap(
      (a) =>({
        label: a.display_name,
        value: a.identifier,
      })
    ) ?? [];
  };

  getCreatedByValues = (): Array<ReactSelectOption<number>> => {
    const options: Array<ReactSelectOption<number>> = [];
    if (!this.props.isLoading.getInterventions) {
      // Created by me
      if (this.props.userInfo) {
        options.push({
          value: this.props.userInfo?.id ?? -1,
          label: "Me",
        });
      }

      // Platform option
      options.push({
        value: 0,
        label: "ReadyCoach",
      });
      // Unique district users (any intervention with a district, not created by me)
      const uniqueDistricts = Array.from(
        new Set(
          this.props.interventions
            .filter(
              (e) =>
                e.district &&
                (!this.props.userInfo ||
                  e.created_by_user?.id !== this.props.userInfo.id)
            )
            .map((e) => e.district)
        )
      );
      uniqueDistricts.forEach((district) => {
        // Ensure district is a number, otherwise skip
        const districtNumber =
          typeof district === "number"
            ? district
            : Number(district);
        if (!isNaN(districtNumber)) {
          options.push({
            value: districtNumber,
            label: `Other Users in the District`,
          });
        }
      });
    }

    return options;
  };

  targetPersonFilter = (
    targetPersonFilter: ReactSelectOption<InterventionTarget> | undefined = this
      .state.targetPersonFilter
  ) => (intervention: Intervention) => {
    if (!targetPersonFilter) return true;
      if(InterventionTarget.INDIVIDUALS === +targetPersonFilter.value){
      return (
        intervention.target === +InterventionTarget.INDIVIDUALS 
      );
    } else if(InterventionTarget.SMALL_GROUP === +targetPersonFilter.value){
      return (
        intervention.target === +InterventionTarget.SMALL_GROUP
      );
    }  else if(InterventionTarget.WHOLE_CLASS === +targetPersonFilter.value){
      return (
        intervention.target === +InterventionTarget.WHOLE_CLASS
      );
    }  else if(InterventionTarget.ALL === +targetPersonFilter.value){
      return (
        intervention.target === InterventionTarget.ALL
      );
    }  else if(ExtendedInterventionTarget.INDIVIDUALS_AND_SMALL_GROUPS === +targetPersonFilter.value){
      return (
        intervention.target === ExtendedInterventionTarget.INDIVIDUALS_AND_SMALL_GROUPS
      );
    }  else if(ExtendedInterventionTarget.WHOLE_CLASS_AND_SMALL_GROUPS === +targetPersonFilter.value){
      return (
        intervention.target === ExtendedInterventionTarget.WHOLE_CLASS_AND_SMALL_GROUPS
      );
    }
  };

  concernTypeFilter = (
    concernTypeFilter: ReactSelectOption<ConcernType> | undefined = this.state
      .concernTypeFilter
  ) => (intervention: Intervention) => {
    if (!concernTypeFilter) return true;
    return intervention.concern_type === +concernTypeFilter.value;
  };

  areaFilter = (
    areaFilter: ReactSelectOption<string> | undefined = this.state.areaFilter
  ) => (intervention: Intervention) => {
    if (!areaFilter) return true;
    if (intervention.skill_areas) {
      return intervention.skill_areas.includes(areaFilter.value.toString());
    } else {
      return false;
    }
  };

  areaOfNeedFilter = (
    areaOfNeedFilter: ReactSelectOption<string> | undefined = this.state.areaOfNeedFilter
  ) => (intervention: Intervention) => {
    if (!areaOfNeedFilter) return true;
    if (intervention.skill_areas) {
      if (areaOfNeedFilter.value.toString() === 'diag_area_early_phonemic_awareness') {
        return intervention.skill_areas?.includes('diag_area_early_phonemic_awarene') 
        || intervention.skill_areas?.includes('diag_area_early_phonemic_awareness');
      } else {
        return intervention.skill_areas.includes(areaOfNeedFilter.value.toString());
      }
    } else {
      return false;
    }
  };

  createdByFilter = (
    createdByFilter: ReactSelectOption<number> | undefined = this.state
      .createdByFilter
  ) => (intervention: Intervention) => {
    if (!createdByFilter) return true;
    
      if (createdByFilter.value === 0) {
        return intervention.is_system_intervention;
      }
      if (this.props.userInfo && +createdByFilter.value === this.props.userInfo.id) {
        return intervention.created_by_user?.id === this.props.userInfo.id;
      }
      // District filter: match actual district value
      if (this.props.userInfo && intervention.district && intervention.district === createdByFilter.value) {
        return intervention.created_by_user?.id !== this.props.userInfo.id;
      }
      return false;
  };

  searchStringFilter = (searchStringFilter = this.state.searchStringFilter) => (
    intervention: Intervention
  ) => {
    if (!searchStringFilter) return true;
    return intervention.name
      .toLowerCase()
      .includes(searchStringFilter.toLowerCase());
  };

  handleTargetPersonFilterChange = (
    value: ValueType<ReactSelectOption<InterventionTarget>, false>
  ) => {
    if (value) {
      const targetPersonFilter = value as ReactSelectOption<InterventionTarget>;
      this.setState({
        targetPersonFilter: targetPersonFilter,
        interventions: this.getInterventions()
          .filter(this.targetPersonFilter(targetPersonFilter))
          .filter(this.concernTypeFilter())
          .filter(this.areaFilter())
          .filter(this.areaOfNeedFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    } else {
      this.setState({
        targetPersonFilter: undefined,
        interventions: this.getInterventions()
          .filter(this.concernTypeFilter())
          .filter(this.areaFilter())
          .filter(this.areaOfNeedFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    }
  };

  handleConcernTypeFilterChange = (
    value: ValueType<ReactSelectOption<ConcernType>, false>
  ) => {
    if (value) {
      const concernTypeFilter = value as ReactSelectOption<ConcernType>;
      this.setState({
        concernTypeFilter: concernTypeFilter,
        interventions: this.getInterventions()
          .filter(this.concernTypeFilter(concernTypeFilter))
          .filter(this.targetPersonFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    } else {
      this.setState({
        concernTypeFilter: undefined,
        interventions: this.getInterventions()
          .filter(this.targetPersonFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    }
  };

  handleAreaFilterChange = (
    value: ValueType<ReactSelectOption<string>, false>
  ) => {
    if (value) {
      const areaFilter = value as ReactSelectOption<string>;
      this.setState({
        areaFilter: areaFilter,
        interventions: this.getInterventions()
          .filter(this.areaFilter(areaFilter))
          .filter(this.targetPersonFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    } else {
      this.setState({
        areaFilter: undefined,
        interventions: this.getInterventions()
          .filter(this.targetPersonFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    }
  };

  handleAreaOfNeedFilterChange = (
    value: ValueType<ReactSelectOption<string>, false>
  ) => {
    
    if (value) {
      const areaOfNeedFilter = value as ReactSelectOption<string>;
      this.setState({
        areaOfNeedFilter: areaOfNeedFilter,
        interventions: this.getInterventions()
          .filter(this.areaOfNeedFilter(areaOfNeedFilter))
          .filter(this.targetPersonFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    } else {
      this.setState({
        areaOfNeedFilter: undefined,
        interventions: this.getInterventions()
          .filter(this.targetPersonFilter())
          .filter(this.createdByFilter())
          .filter(this.searchStringFilter()),
      });
    }
  };

  handleCreatedByFilterChange = (
    value: ValueType<ReactSelectOption<number>, false>
  ) => {
    const createdByFilter = value as ReactSelectOption<number>;
    this.setState({
      createdByFilter: createdByFilter,
      interventions: this.getInterventions()
        .filter(this.createdByFilter(createdByFilter))
        .filter(this.targetPersonFilter())
        .filter(this.concernTypeFilter())
        .filter(this.areaFilter())
        .filter(this.areaOfNeedFilter())
        .filter(this.searchStringFilter()),
    });
  };

  handleSearchStringFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const searchStringFilter = event.target.value;
    this.setState({
      searchStringFilter: searchStringFilter,
      interventions: this.getInterventions()
        .filter(this.searchStringFilter(searchStringFilter))
        .filter(this.createdByFilter())
        .filter(this.targetPersonFilter())
        .filter(this.concernTypeFilter())
        .filter(this.areaFilter())
        .filter(this.areaOfNeedFilter()),
    });
  };

  handleInterventionSelect = (intervention: Intervention) => {
    this.setState({ selectedIntervention: intervention, step: 1 });
  };

  handleBackToCatalogClick = () => {
    this.setState({ 
      selectedIntervention: undefined,
       step: 0,
       shareByDistrict: false
      });
  };

  handleBackToInterventionInfoClick = () => {
    this.setState({ step: 1 });
  };

  handleBackToSharedInfoClick = () => {
    this.setState({ step: 2 });
  };

  handleUseThisInterventionClick = () => {
    this.setState({ showModifyInterventionPopup: true });
  };

  handleModifyInterventionPopupClose = () => {
    this.setState({ showModifyInterventionPopup: false });
  };

  handleAddInterventionsToGroup = () => {
    const { interventionGroup, isSaveInState } = this.props;
    const { selectedIntervention } = this.state;
    if (interventionGroup && selectedIntervention) {
      if (isSaveInState) {
        if (
          !(interventionGroup.interventions || []).some(
            (int) => int.id === selectedIntervention.id
          )
        ) {
          this.props.changeSelectedInterventionGroup({
            ...interventionGroup,
            interventions: (interventionGroup.interventions || []).concat(
              selectedIntervention
            ),
          });
        }
        this.props.hideInterventionLibraryModal();
      } else {
        const ids = (interventionGroup.interventions || []).map(
          (intervention) => intervention.id
        );
        this.props.addInterventionsToGroup(
          interventionGroup.id!,
          ids.concat([selectedIntervention.id])
        );
      }
    }
  };

  handleInterventionModify = () => {
    this.setState({ showModifyInterventionPopup: false, shareByDistrict:false, step: 2 });
  };

  getInterventions = () => {
    if (this.state.recommendedOnly)
      return this.getRecommendedOnlyInterventions();
    else return this.props.interventions;
  };

  handleRecommendedOnlyCheck = (checked: boolean) => {
    if (checked) {
      this.setState((prevState) => ({
        ...prevState,
        recommendedOnly: true,
        interventions: this.getRecommendedOnlyInterventions()
          .filter(this.createdByFilter())
          .filter(this.targetPersonFilter())
          .filter(this.concernTypeFilter())
          .filter(this.areaFilter())
          .filter(this.areaOfNeedFilter())
          .filter(this.searchStringFilter()),
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        recommendedOnly: false,
        interventions: this.props.interventions
          .filter(this.createdByFilter())
          .filter(this.targetPersonFilter())
          .filter(this.concernTypeFilter())
          .filter(this.areaFilter())
          .filter(this.areaOfNeedFilter())
          .filter(this.searchStringFilter()),
      }));
    }
  };

  
  getDownloadButtonForIntervention = (intervention: Intervention) => {
    //const attachments = intervention.attachments;
    let attachmentURL = '';
    if(window.location.host.includes('localhost')) {
      attachmentURL = 'http://localhost:8000'
    } else if (window.location.host === 'staging.readycoach.net'){
      attachmentURL = 'https://stage-api.readycoach.net'
    } 
  const attachments = [...intervention.attachments, ...intervention.checklist_items.flatMap((ci) => ci.attachments)];
  if (attachments.length === 1) {
      return (
        <a
        href={attachmentURL + attachments[0].attachment_url!}
        target="_blank"
        rel="noopener noreferrer"
        className="interventionPdfButton"
      >
        <FontAwesomeIcon icon={faDownload} />
        PDF
      </a>
      );
    } else if (attachments.length >= 2) {
      return (
        <Dropdown className="m-1 recommendationsSelectInterventions">
          <Dropdown.Toggle id="dropdown-basic">
            <button className="blueBtnSm">PDF</button>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {attachments.map((attachment) => (
              <Dropdown.Item key={attachment.id} as="button">
                <a
                href={attachmentURL + (attachment.attachment_url! || attachment.url!)}
                target="_blank"
                rel="noopener noreferrer"
                //onClick={downloadFile(attachment.attachment_url! || attachment.url!)}
                key={attachment.url}
              >
                  {attachment.title}
                </a>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
  };

  setShareByDistrict = (checked: any) => {
    this.setState({
      shareByDistrict: checked
    });
  }

  handleReportGenerate = () => {
    if (this.defState.contentRef.current) {
      // Sanitize filename: remove all illegal characters and dots, collapse spaces
      let safeName = (this.state.selectedIntervention?.name || "Generated Report")
        .replace(/[:/\\?%*|"<>]/g, "-")
        .replace(/\./g, "-")
        .replace(/\s+/g, " ")
        .trim();
      // Fallback if name is empty after sanitization
      if (!safeName) safeName = "Checklist";
      const filename = `${safeName} - Checklist Steps.pdf`;
      const opt = {
        margin: [8, 8, 8, 8] as [number, number, number, number],
        filename,
        enableLinks: false,
        pagebreak: {
          avoid: ["div", "tr"],
          mode: ["css", "legacy"],
        },
        image: { type: "jpeg" as const, quality: 1 },
        html2canvas: {
          allowTaint: true,
          dpi: 300,
          letterRendering: true,
          logging: false,
          scale: 2,
          scrollX: 0,
          scrollY: 0,
        },
        jsPDF: { unit: "pt", format: "letter", orientation: "portrait" as 'portrait' },
      };

      // Use .save(filename) to force the name if html2pdf fallback occurs
      // @ts-ignore
      html2pdf()
        .from(this.defState.contentRef.current)
        .set({
          ...opt,
          html2canvas: {
            ...opt.html2canvas,
            useCORS: true,
          },
        })
        .save(filename);
    }
  };

  getTooltipText = () => {
  return this.state.recommendedOnly ? (
    <>
    Showing recommended interventions. Uncheck <br/> <strong> “Recommended only”</strong> to view all available options.
    </>
  ) : (
    <>
    Showing all available interventions. Check <br/> <strong> “Recommended only”</strong>  to view suggested options.
    </>
  );
  };

  getModalBodyByStep = () => {
    switch (this.state.step) {
      case 0: {
        const {
          interventions,
          targetPersonFilter,
          concernTypeFilter,
          areaFilter,
          areaOfNeedFilter,
          createdByFilter,
          searchStringFilter,
        } = this.state;
       
        return (
          <>
            <h4 className="mb-3">
              Select an intervention to support this group’s goal. Start with recommended options or explore all
               interventions. Click any intervention to view details.
            </h4>
            {this.props.interventionGroup?.recommendation_group_key == null ? 
              <Alert variant="warning">
                <strong>Note:</strong> This group was created through manual grouping, 
                so the intervention library is not filtered by recommendations, 
                and all interventions in the library are listed below. 
              </Alert>
              : ''}
            <InputGroup className="filterSearchDesktop"  style={{width:"300px"}}>
              <InputGroup.Prepend>
                <InputGroup.Text className="px-2">
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                placeholder="Search"
                value={this.state.searchStringFilter}
                onChange={this.handleSearchStringFilterChange}
                className="filterSearchHeight"
              />
            </InputGroup>
            <hr />    
            <Row className="mt-4 mb-4">
              <Col sm={3} style={{ borderRight: "1px #cfd8dc solid" }}>
                <div className="recommendationsSettingRow default-pointer" style={{fontSize:"1.1rem"}}>Filters</div>
                {this.props.interventionGroup?.recommendation_group_key !== null ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="recommended-tooltip">
                        <div>
                          {this.getTooltipText()}
                        </div>
                      </Tooltip>
                    }
                  >
                  <div>
                    <FormCheck
                      className="font-weight-bold my-2 text-dark"
                      custom
                      checked={this.state.recommendedOnly}
                      onChange={(event) => this.handleRecommendedOnlyCheck(event.target.checked)}
                      type="checkbox"
                      id="recommendationOnly"
                      label={`Recommended only`}
                    />
                  </div>
                  </OverlayTrigger>) : ''}
                  <Form.Label className="mb-0 mt-2 font-weight-bold text-dark">
                    Target Person
                  </Form.Label>
                  <Select
                    // isDisabled={
                    //   !!this.props.interventionGroup?.recommendation_group_key
                    // }
                    name="targetPersonFilter"
                    isClearable
                    value={targetPersonFilter}
                    options={this.getInterventionTargetValues()}
                    onChange={this.handleTargetPersonFilterChange}
                    placeholder="Select"
                  />
                  <Form.Label className="mb-0 mt-2 font-weight-bold text-dark">
                    Type of Concern
                  </Form.Label>
                  <Select
                    // isDisabled={
                    //   !!this.props.interventionGroup?.recommendation_group_key
                    // }
                    name="concernTypeFilter"
                    isClearable
                    value={concernTypeFilter}
                    options={this.getConcernTypeValues()}
                    onChange={this.handleConcernTypeFilterChange}
                    placeholder="Select"
                  />
                  <Form.Label className="mb-0 mt-2 font-weight-bold text-dark">
                    Areas of Need
                  </Form.Label>
                  <Select
                    // isDisabled={
                    //   !!this.props.interventionGroup?.recommendation_group_key
                    // }
                    isClearable
                    name="areaOfNeedFilter"
                    value={areaOfNeedFilter}
                    options={this.getAreaOfNeedValues()}
                    onChange={this.handleAreaOfNeedFilterChange}
                    placeholder="Select"
                  />
                  <Form.Label className="mb-0 mt-2 font-weight-bold text-dark">
                    Created by
                  </Form.Label>
                  <Select
                    // isDisabled={
                    //   !!this.props.interventionGroup?.recommendation_group_key
                    // }
                    name="createdByFilter"
                    isClearable
                    value={createdByFilter}
                    options={this.getCreatedByValues()}
                    onChange={this.handleCreatedByFilterChange}
                    placeholder="Select"
                  />
                <br />
              </Col>
              <Col sm={9}>
                <div className="recommendationsSettingRow default-pointer mb-2" style={{fontSize:"1.1rem"}}>
                  Area of Concern:{" "}
                  {this.props.interventionGroup?.goal_type ? (
                    GoalTypesDisplayedNames[
                      this.props.interventionGroup.goal_type
                    ]
                  ) : (
                    <i>none</i>
                  )}
                </div>
                <div data-cy="intervention-list" className="interventionList">
                  {!this.props.interventions.length ? (
                    <h2>Interventions Not found</h2>
                  ) : (
                    !interventions.length && (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '400px'}}>
                        <h2>
                          {this.state.recommendedOnly ? (
                            <>
                              <strong>No recommended interventions found</strong> <br />
                              <h4 className="font-italic">
                                Try unchecking “Recommended only” or adjusting your search.
                              </h4>
                            </>
                          ) : (
                            <>
                              <strong>No interventions found</strong> <br />
                              <h4 className="font-italic">
                                Try adjusting your search or filters.
                              </h4>
                            </>
                          )}
                        </h2>
                      </div>
                    )
                  )}
                  {this.props.isLoading.getInterventions 
                  ? <LoadingIndicator type="intervention" />
                  : (interventions.length > 0) && uniqueByKey(interventions, 'id').map((intervention) => (
                    <InterventionItem
                      key={`intervention_${intervention.id}`}
                      intervention={intervention}
                      onSelect={this.handleInterventionSelect}
                    />
                  ))}
                </div>
              </Col>
            </Row>
            <hr />
            <div className="btnActions d-flex justify-content-center">
              <div className="whiteBtnSm" onClick={this.handleBackClick}>
                Close
              </div>
            </div>
          </>
        );
      }
      case 1: {
        return (
          <div data-cy="intervention-info">
            <div className="d-flex justify-content-start mb-4">
              {
              !this.props.selectedIntervention ?
              // ? 
              //   (
              //     <InterventionEditButton
              //       intervention={this.props.selectedIntervention}
              //       interventionGroupId={this.props.interventionGroup?.id}
              //     />
              //   ) : 
                (
                  <button
                    data-cy="use-this-intervention-btn"
                    className="blueBtnLg ml-auto text-nowrap"
                    onClick={this.handleUseThisInterventionClick}
                  >
                    Use this intervention
                  </button>
                ) : ''
              }
            </div>
            <hr />
            <Row className="mx-0" style={{ textAlign: "left" }}>
              <Col className="p-0">
                {this.state.selectedIntervention!.description && (
                  <>
                    <h3>Description</h3>
                    <p>{this.state.selectedIntervention!.description}</p>
                  </>
                )}
                {this.state.selectedIntervention!.purpose && (
                  <>
                    <h3>Purpose</h3>
                    <p>{this.state.selectedIntervention!.purpose}</p>
                  </>
                )}
                {this.state.selectedIntervention!.considerations && (
                  <>
                    <h3>Considerations</h3>
                    <p>{this.state.selectedIntervention!.considerations}</p>
                  </>
                )}
                {this.state.selectedIntervention!.preparation && (
                  <>
                    <h3>Preparation</h3>
                    <p>{this.state.selectedIntervention!.preparation}</p>
                  </>
                )}
                {this.state.selectedIntervention!.prerequisites && (
                  <>
                    <h3>Prerequisites</h3>
                    <ul>
                      {this.state
                        .selectedIntervention!.prerequisites.trim()
                        .split("\n")
                        .map((pr) => (
                          <li>{pr}</li>
                        ))}
                    </ul>
                  </>
                )}
                {this.state.selectedIntervention!.setup_steps?.length > 0 && (
                  <>
                    <h3>Setup Steps</h3>
                    <ul style={{ marginTop: 8 }}>
                      {this.state.selectedIntervention!.setup_steps?.map(
                        (step) => (
                          <li>
                            <strong>{step.title}</strong>
                            {step.details &&
                              step.details.trim() !== "-" &&
                              step.details.trim().length > 1 &&
                              `: ${step.details}`}
                          </li>
                        )
                      )}
                    </ul>
                  </>
                )}
              </Col>
            </Row>

            {!!this.state.selectedIntervention?.checklist_items?.length && (
              <div className="mt-3">
                <div className="d-flex justify-content-between mb-2">
                  <h3 style={{ marginBottom: 10 }}>Checklist Items</h3>
                  <button
                    className="float-right whiteBtnSm"
                    onClick={this.handleReportGenerate}
                  >
                    Generate Checklist PDF
                  </button>
                </div>
                <div ref={this.defState.contentRef as React.RefObject<HTMLDivElement>}>
                  {this.state.selectedIntervention.checklist_items
                    .sort((a, b) => a.order - b.order)
                    .map((checkListItem, index) => (
                      <>
                        {checkListItem.header && (
                          <div
                            className={"checklistItemHeader"}
                            key={`header_${checkListItem.id}`}
                          >
                            <span className="pdfFontFamily">{checkListItem.header}</span>
                          </div>
                        )}

                        <div
                          className="interventionStepsBtnWithPlaceholder"
                          key={checkListItem.id}
                        >
                          <div className="pdfFontFamily">Step {index + 1}</div>
                          <div className="pdfFontFamily">
                            <span className="font-weight-bold pdfFontFamily">{checkListItem.title}</span>
                            {checkListItem.details &&
                              checkListItem.details.trim() !== "-" && (
                                <>
                                  <br />
                                  {checkListItem.details}
                                </>
                              )}
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            )}

            {this.state.showModifyInterventionPopup && (
              <ModifyInterventionPopup
                selectedIntervention={this.state.selectedIntervention}
                handleClose={this.handleModifyInterventionPopupClose}
                handleUseAsIs={this.handleAddInterventionsToGroup}
                handleInterventionModify={this.handleInterventionModify}
                loading={this.props.isLoading}
              />
            )}

            <hr />
            <div className="spaceBetween align-items-end">
              <div className="behavConLeftActions">
                <PdfBtn intervention={this.state.selectedIntervention!} />
                {/* {this.getDownloadButtonForIntervention(
                  this.state.selectedIntervention!
                )} */}
              </div>
              {!this.props.selectedIntervention && (
                <button
                  data-cy="use-this-intervention-btn"
                  className="blueBtnLg"
                  onClick={this.handleUseThisInterventionClick}
                >
                  Use this intervention
                </button>
              )}
            </div>
          </div>
        );
      }
      case 2: 
        return (
          <InterventionShared 
            shareByDistrict={this.state.shareByDistrict} 
            setShareByDistrict={this.setShareByDistrict as any}
            onClickNext={() => this.setState({ step: 3 })}
          />
        );
      case 3:
        return (
          <ModifyingInterventionBody
            selectedIntervention={this.state.selectedIntervention!}
            shareByDistrict={this.state.shareByDistrict} 
          />
        );
      default:
        return null;
    }
  };

  getModalTitleByStep = () => {
    switch (this.state.step) {
      case 0:
        return (
          this.props.interventionGroup && (
            <>
              <div>
                <InterventionGroupTooltip
                  interventionGroup={this.props.interventionGroup}
                />
              </div>
              <Modal.Title>
                Add Intervention to {this.props.interventionGroup.name}
              </Modal.Title>
              <ModalCloseButton onClose={this.handleModalClose} />
            </>
          )
        );
      case 1:
        return (
          <>
            {this.props.selectedIntervention ? (
              <div />
            ) : (
              <button
                className="btnModalBack"
                onClick={this.handleBackToCatalogClick}
              >
                <FontAwesomeIcon icon={faChevronLeft} size={"lg"} />
                Back to Catalog
              </button>
            )}
            <Modal.Title>{this.state.selectedIntervention!.name}</Modal.Title>
            <ModalCloseButton onClose={this.handleModalClose} />
            {/*{(*/}
            {/*  <div className="d-flex justify-content-between">*/}
            {/*    <button className="bgInfoBtn ml-4">Background info</button>*/}
            {/*    <ModalCloseButton onClose={this.handleModalClose} />*/}
            {/*  </div>*/}
            {/*)}*/}
          </>
        );
      case 2:
        return (
          <>
            <button
              className="btnModalBack"
              onClick={this.handleBackToInterventionInfoClick}
            >
              <FontAwesomeIcon icon={faChevronLeft} size={"lg"} />
              Back
            </button>
            <Modal.Title>
              Modifying {this.state.selectedIntervention!.name}
            </Modal.Title>
            {/*{(*/}
            {/*  <button className="bgInfoBtn mr-4">Background info</button>*/}
            {/*)}*/}
            <div />
          </>
        );
      case 3:
        return (
          <>
            <button
              className="btnModalBack"
              onClick={this.handleBackToSharedInfoClick}
            >
              <FontAwesomeIcon icon={faChevronLeft} size={"lg"} />
              Back
            </button>
            <Modal.Title>
              Modifying {this.state.selectedIntervention!.name}
            </Modal.Title>
            {/*{(*/}
            {/*  <button className="bgInfoBtn mr-4">Background info</button>*/}
            {/*)}*/}
            <div />
          </>
        );
      default:
        return null;
    }
  };

  render() {
    const { showModal } = this.props;
    return (
      <Modal
        id="intervention-library-modal"
        onShow={this.handleModalShow}
        show={showModal}
        onHide={this.handleModalClose}
        animation={false}
        size="lg"
        backdropClassName="customDarkModalBackdrop inner in"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          closeButton={false}
          className={"purpleModalHeader centerModalHeader"}
        >
          {this.getModalTitleByStep()}
        </Modal.Header>
        <Modal.Body>
          {this.props.isLoading.getInterventions ? (
            <LoadingIndicator />
          ) : (
            this.getModalBodyByStep()
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

// READ_REC_CORE_SUPPORT = "rr_core_support"
// READ_REC_LN = "rr_letter_naming"
// READ_REC_PA = "rr_phonemic_awareness"
// READ_REC_PHONICS = "rr_phonics"
// READ_REC_FLUENCY = "rr_fluency"
// READ_REC_SIGHT_WORDS = "rr_sight_words"
// READ_REC_DECODING = "rr_decoding"

const READ_REC_ID_MAP: {
  [read_rec: string]: string;
} = {
  rr_letter_naming: "diag_area_letter_names", // ??
  rr_phonemic_awareness: "diag_area_phonemic_awareness",
  rr_phonics: "diag_area_phonics",
  rr_fluency: "diag_area_fluency",
  rr_sight_words: "diag_area_phonics", // ??
  rr_decoding: "diag_area_phonics", // ??
  rr_comprehension: "diag_area_comprehension",
};

const BEHAVE_REC_ID_MAP: {
  [behave_rec: string]: string;
} = {
  br_self_awareness: "diag_area_self_awareness",
  br_self_management: "diag_area_self_management",
  br_social_awareness: "diag_area_social_awareness",
  br_relationship_skills: "diag_area_relationship_skills",
  br_goal_directed_behavior: "diag_area_goal_directed_behavior",
  br_personal_responsibility: "diag_area_personal_responsibility",
  br_decision_making: "diag_area_decision_making",
  br_optimistic_thinking: "diag_area_optimistic_thinking"
};

const mapStateToProps = ({
  auth,
  cases,
  groups,
}: ApplicationState): PropsFromState => {
  let intConcernArea:number = 0;
  if((cases.tabName == 'groups/behavior') || (cases.modalsState.interventionCalledFromFBA)){
    intConcernArea = 1;
  }
  let interventions = cases.interventions;
  if(window.location.pathname.includes('groups/reading')) {
    interventions = interventions.filter((intervention: Intervention) => [ConcernArea.ACADEMIC, ConcernArea.BOTH].includes(intervention.concern_area))
  }
  if(window.location.pathname.includes('groups/behavior')) {
    interventions = interventions.filter((intervention: Intervention) => [ConcernArea.BEHAVIOR, ConcernArea.BOTH].includes(intervention.concern_area))
  }
  return {
    callbacks: cases.modalsState.interventionLibraryModalCallbacks,
    interventionGroup: cases.selectedInterventionGroup,
    selectedIntervention: cases.selectedIntervention,
    userInfo: auth.userInfo,
    //interventions: cases.interventions.filter((intervention:Intervention) => (intervention.concern_area == intConcernArea) || intervention.concern_area == 2 ),
    interventions: interventions,
    skillFocusInfo: groups.skillFocusInfo,
    identifiersInfo: groups.identifiersInfo,
    showModal: cases.modalsState.interventionLibraryModal,
    interventionCalledFromFBA: cases.modalsState.interventionCalledFromFBA,
    isSaveInState: cases.modalsState.isSaveInState,
    createdIntervention: cases.createdIntervention,
    isLoading: {
      addInterventionsToGroup: cases.isLoading.addInterventionsToGroup,
      getInterventions: cases.isLoading.getInterventions,
    },
    errors: {
      addInterventionsToGroup: cases.errors.addInterventionsToGroup,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getInterventions: getInterventions,
      hideInterventionLibraryModal: hideInterventionLibraryModal,
      getSkillFocuses: getSkillFocuses,
      addInterventionsToGroup: addInterventionsToGroup,
      changeSelectedInterventionGroup: changeSelectedInterventionGroup,
      patchInterventionGroup: patchInterventionGroup,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InterventionLibraryModal));